import { Link } from '@tanstack/react-router';
import React from 'react';

interface DesktopArtistCardProps {
  day: string;
  bandName: string;
  image: string;
  slug: string;
}

const DesktopCard: React.FC<DesktopArtistCardProps> = ({
  bandName,
  slug,
  image,
}) => {
  return (
    <Link to="/artists/$slug" params={{ slug }} className="no-underline">
      <div className="bg-opacity-70 flex flex-col overflow-hidden rounded-lg bg-neutral-800 shadow-lg">
        <img
          src={image}
          alt={bandName}
          className="w-full"
        />
        {/* <div className="bg-amber-100 text-black text-center py-2.5 px-3 font-semibold border-t-4 border-orange-500 mt-auto text-sm"> */}
        {/* </div> */}
      </div>
    </Link>
  );
};

export default DesktopCard;
